// extracted by mini-css-extract-plugin
export var actionButton = "_8x-1";
export var actionButtons = "_8x-2";
export var actions = "_8x-0";
export var aiUnread = "_8x-10";
export var alignCenter = "_8x-h";
export var backWrapper = "_8x-3";
export var cellContainer = "_8x-4";
export var checkboxContainer = "_8x-5";
export var contentContainer = "_8x-6";
export var contentHeader = "_8x-8";
export var conversationsTableWrapper = "_8x-s";
export var draftReplyBadgeContainer = "_8x-m";
export var dropdownItem = "_8x-b";
export var dropdownItemsContainer = "_8x-a";
export var dropdownTitle = "_8x-c";
export var errorIcon = "_8x-7";
export var filter = "_8x-d";
export var gray = "_8x-i";
export var headerActionButtons = "_8x-e";
export var headerCheckboxContainer = "_8x-f";
export var icon = "_8x-j";
export var menuContainer = "_8x-k";
export var noMoreTicketsIcon = "_8x-12";
export var noMoreTicketsSubText = "_8x-13";
export var oneLine = "_8x-l";
export var optionsButton = "_8x-n";
export var plus = "_8x-o";
export var portalButtonsWrapper = "_8x-g";
export var red = "_8x-p";
export var scrolledTop = "_8x-9";
export var search = "_8x-q";
export var selectedConversationsCount = "_8x-r";
export var spinner = "_8x-t";
export var strong = "_8x-u";
export var summaryCell = "_8x-v";
export var tableContainer = "_8x-11";
export var tagContainer = "_8x-w";
export var threeDots = "_8x-x";
export var twoLines = "_8x-y";
export var unread = "_8x-z";